import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { HttpService } from '@app/@core/services/http.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';

const IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.webp'];

export function isEducatorDocumentImageFileName(fileName: string | null | undefined): boolean {
  const name = String(fileName ?? '').toLowerCase();
  return IMAGE_EXTENSIONS.some(ext => name.endsWith(ext));
}

/** Extract blob/file URL from educator document download API response shapes. */
export function resolveEducatorDocumentFileUrl(response: unknown): string | null {
  const r = response as Record<string, unknown> | null | undefined;
  const data = r?.data as Record<string, unknown> | undefined;
  const inner = data?.data as Record<string, unknown> | undefined;
  const blob = (inner?.p_document_blob ?? data?.p_document_blob) as Record<string, unknown> | undefined;
  return (
    (blob?.file_url as string) ??
    (blob?.fileUrl as string) ??
    (blob?.strfileHash as string) ??
    (blob?.file_hash as string) ??
    (blob?.fileHash as string) ??
    (data?.file_url as string) ??
    (data?.fileUrl as string) ??
    (data?.url as string) ??
    (r?.file_url as string) ??
    (r?.fileUrl as string) ??
    null
  );
}

export function fetchEducatorDocumentUrl(
  http: HttpService,
  documentId: number
): Observable<string | null> {
  const payload = { profile_document_upload_id: documentId };
  return http.post<unknown>(API_ENDPOINTS.EDUCATOR_COMMUNICATION_DOWNLOAD, payload).pipe(
    map(res => resolveEducatorDocumentFileUrl(res))
  );
}
